module.exports = __webpack_public_path__ + "img/export-icon.893e1ad4.svg";